// extracted by mini-css-extract-plugin
module.exports = {"panelContainer":"styles_panelContainer__3V2sJ","slideInFromRight":"styles_slideInFromRight__2vK1S"};